import ResponsiveStyleSheet from "react-native-media-query";
import { theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  panel: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: theme.spacing.small,
  },
  editButton: {
    alignSelf: "center",
    fontFamily: "ProximaSemiBold",
    borderBottomColor: theme.colors.brand.base,
    borderBottomWidth: 2,
  },
  heading: {
    marginBottom: theme.spacing.large,
  },
  panelWrap: {
    marginBottom: theme.spacing.small,
  },
});
